import React from "react";
import { useDropzone } from "react-dropzone";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import LinearProgress from "@mui/material/LinearProgress";
import UploadIcon from "@mui/icons-material/Upload";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import { toast } from "react-hot-toast";

function FileUpload(props) {
  const {
    progressPercent,
    file,
    state,
    handleUploadFile,
    sendEmailToDevTeam,
    handleDownloadErrorFile,
    handleCloseDialog,
    cancelDisabled,
    component,
    type
  } = props;

  const { templateFile, listFile } = state;
  const onDrop = async (acceptedFiles) => {
    if (component === "hip") {
      if (acceptedFiles.length > 0 &&
        (acceptedFiles[0]?.name?.endsWith(".json") ||
          acceptedFiles[0]?.name?.endsWith(".json"))) handleUploadFile(acceptedFiles[0], type);
    }
    else if (
      acceptedFiles.length > 0 &&
      (acceptedFiles[0]?.name.endsWith(".xls") ||
        acceptedFiles[0]?.name.endsWith(".xlsx"))
    ) {
      handleUploadFile(acceptedFiles[0]);
    } else {
      toast.error("File format is not correct.");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: component === "hip" ? "application/json" : "application/vnd.ms-excel",
    onDrop,
    maxFiles: 1,
    onDropRejected: (rejectedFiles) => {
      if (rejectedFiles?.length > 1) toast.error("You can upload only one file at a time.");
    },
  });

  const fileView = (file) => (
    <Box className="fileBox">
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={2}>
              <Card className="ptFileCard">
                <DescriptionOutlinedIcon className="ptFileIcon" />
              </Card>
            </Grid>
            <Grid item xs={9}>
              <Typography className="ptFileName">{file?.name}</Typography>
              <Typography className="ptFileSize">{`${(file?.size / 1024).toFixed(2)} KB`}</Typography>
            </Grid>
            <Grid item xs={1}>
              <IconButton
                onClick={() => handleCloseDialog(true, "file", templateFile?.name ? "template" : "list")}
                disabled={cancelDisabled()}
                className="closeButton"
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
        {progressPercent !== 100 && !templateFile && !listFile ? (
          <Grid container mt={2} gap={2}>
            <Grid item xs={10.5}>
              <LinearProgress
                variant="determinate"
                value={progressPercent}
              />
            </Grid>
            <Grid item xs={1} mt={-1}>
              <Typography>{`${progressPercent}%`}</Typography>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  )

  return (
    <>
      <div {...getRootProps()}>
        <Grid container display={"flex"} className="uploadBox">
          <input {...getInputProps()} />
          <Grid item xs={12} display={"flex"} justifyContent={"center"} my={2}>
            <UploadIcon />
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent={"center"}
            my={1}
            gap={1}
          >
            <Typography className="uploadTitle">{`Click to upload`}</Typography>
            <Typography className="ptUploadDesc">{`or drag and drop`}</Typography>
          </Grid>
          <Grid item xs={12} display={"flex"} justifyContent={"center"} my={1}>
            <Typography sx={{ color: "#cbcdd1" }}>
              {"Maximum file size 500 MB."}
            </Typography>
          </Grid>
        </Grid>
      </div>
      {file ? fileView(file) : null}
      {state?.fileImportError && (
        <Grid container mb={2}>
          <Grid item xs={12}>
            <Typography
              fontWeight={400}
              fontSize={12}
            >{`There was a problem with the file.`}</Typography>
          </Grid>
          <Grid container mt={1}>
            <Grid item xs={6} display={"flex"} gap={1}>
              <DownloadIcon className="templateContactUs" />
              <Typography
                fontWeight={400}
                fontSize={12}
                value="download"
                onClick={() => handleDownloadErrorFile()}
                className="ptDownloadBtn"
              >{`Download error report`}</Typography>
            </Grid>
            <Grid item xs={6} display={"flex"} gap={1}>
              <ShortcutIcon className="templateContactUs" />
              <Typography
                onClick={() => sendEmailToDevTeam()}
                fontWeight={400}
                fontSize={12}
                className="ptDownloadBtn"
              >{`Send to dev team`}</Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default FileUpload;
